import { BaseModel } from '../base-model';

export interface IPropertyConfigurations {
  GeneralPubTitleA?: string;
  GeneralPubTitleB?: string;
  GeneralPubTitleC?: string;
  GeneralPubTitleD?: string;
  GeneralDescTitleA?: string;
  GeneralDescTitleB?: string;
  DaysToSendCandidateAfterEndContract?: number;
  ContractDurationMonths?: number;
  ReferenceFormatString?: string;
  VATValue?: number;
  PersonTypesDefaultSendAppointmentConfirmations: any;
  FloorPlannerUrlFormat?: string;
  HomeStylerUrlFormat?: string;
  MatterPortUrlFormat?: string;
  UseAutoMatching?: boolean;
    ShowUserCommission?: boolean;
    CanReadWriteInvoiceTabRight?: number;
    UseInvoiceCommission?: boolean;
}
export class PropertyConfigurations extends BaseModel<IPropertyConfigurations> implements IPropertyConfigurations {
  GeneralPubTitleA: string;
  GeneralPubTitleB: string;
  GeneralPubTitleC: string;
  GeneralPubTitleD: string;
  GeneralDescTitleA: string;
  GeneralDescTitleB: string;
  DaysToSendCandidateAfterEndContract: number;
  ContractDurationMonths: number;
  ReferenceFormatString: string;
  VATValue?: number;
  PersonTypesDefaultSendAppointmentConfirmations: any;
  FloorPlannerUrlFormat?: string;
  HomeStylerUrlFormat?: string;
  MatterPortUrlFormat?: string;
  UseAutoMatching?: boolean;
    ShowUserCommission?: boolean;
    CanReadWriteInvoiceTabRight?: number;
    UseInvoiceCommission?: boolean;
  /**
   *
   */
  constructor(option?: IPropertyConfigurations) {
    super(option)
  }
}